import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentHeading from "../../shared/commonComponents/ContentHeading";
import SolutionItem from "../../shared/commonComponents/SolutionItem";
import PostComment from "../discussionBoard/postComment";
import Comment from "../discussionBoard/comment";
import { Spinner } from "react-bootstrap";

import { NetworkAxios, ProgramSetupAxios, UserActivityAxios } from "../../API";
//import SolutionSlice from "../../store/Gallery/solutionSlice";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
//import { Modal, Button } from "react-bootstrap";

import { Rating } from "react-simple-star-rating";
import CdxModal from "../../shared/modal/CdxModal";
import { TextAreaInput } from "../../shared/inputs";
import ShowMore from "../../shared/commonComponents/ShowMore";

const NominateTab = () => {
  let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };
  // const solutions = useSelector((state) => state.solutions.solutions);
  const [solutionList, setSolutionList] = useState([]);
  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  const [selectedForum, setSelectedForum] = useState(null);
  const [selectedForumId, setSelectedForumId] = useState(
    loggedInUser.conclaveForumId
  );
  const [dataLoading, setDataLoading] = useState(true);
  //const dispatch = useDispatch();

  const setLikeItem = (islike, item) => {
    var temp = [...selectedForum.comments];
    if (
      item.parentCommentId == null ||
      item.parentCommentId == undefined ||
      item.parentCommentId == 0
    ) {
      var index = temp
        .map(function (e) {
          return e.id;
        })
        .indexOf(item.id);
      temp[index]["isLiked"] = islike;
      if (islike) {
        temp[index]["likes"] = temp[index]["likes"] + 1;
      } else {
        temp[index]["likes"] = temp[index]["likes"] - 1;
      }
    } else {
      var parentIndex = temp
        .map(function (e) {
          return e.id;
        })
        .indexOf(item.parentCommentId);
      var index = temp[parentIndex]["replies"]
        .map(function (e) {
          return e.id;
        })
        .indexOf(item.id);
      temp[parentIndex]["replies"][index]["isLiked"] = islike;
      if (islike) {
        temp[parentIndex]["replies"]["likes"] =
          temp[parentIndex]["replies"]["likes"] + 1;
      } else {
        temp[parentIndex]["replies"]["likes"] =
          temp[parentIndex]["replies"]["likes"] - 1;
      }
    }
    var tempObj = { ...selectedForum };
    tempObj.comments = [...temp];
    setSelectedForum({ ...tempObj });
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [activeShowMore, setActiveShowMore] = useState(false);
  const [pageSize, setPageSize] = useState(10000);
  const [onClickShowMore, setOnClickShowMore] = useState(false);

  useEffect(() => {
    if (onClickShowMore) {
      getForumComments();
    }
  }, [onClickShowMore]);

  const getForumComments = () => {
    var tempPageNumber = 1;
    if (onClickShowMore) {
      tempPageNumber = pageNumber;
    }

    NetworkAxios.get(
      `Forum/getforumbyid/${loggedInUser.conclaveForumId}/${loggedInUser.offeringUserId}/${tempPageNumber}/${pageSize}`
    )
      .then((res) => {
        //setSelectedForum({});
        //setSelectedForum(res.data);

        if (onClickShowMore) {
          var tempSelectedForumComments = JSON.parse(JSON.stringify(selectedForum.comments));
          var totalComments = tempSelectedForumComments.concat(res.data.comments);
          setSelectedForum({ ...selectedForum, comments: totalComments });
          setOnClickShowMore(false);
          if (totalComments.length == pageSize * pageNumber) {
            setPageNumber(pageNumber + 1);
            setActiveShowMore(true);
          } else {
            setActiveShowMore(false);
          }
        } else {
          setSelectedForum(res.data);
          setOnClickShowMore(false);
          //setPageNumber(1);
          if (res.data.comments.length == pageSize) {
            setPageNumber(2);
            setActiveShowMore(true);
          } else {
            setActiveShowMore(false);
          }
        }

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const reloadData = () => {
    getForumComments();
  };

  useEffect(() => {
    getForumComments();
  }, []);

  const [overallRating, setOverallRating] = useState([]);
  const [offeringRatings, setOfferingRatings] = useState([]);
  const [selectedSolution, setSelectedSolution] = useState(null);
  const [showNominationModal, setShowNominationModal] = useState(false);

  const [offeringRatingTypes, setOfferingRatingTypes] = useState([]);
  //const [rating, setRating] = useState(0);
  const [feedbackText, setFeedbackText] = useState("");
  // const [selectedItem, setSelectedItem] = useState("");
  const [updatedRatings, setUpdatedRatings] = useState([]);
  //const [button, setButton] = useState("Rate");
  const [errorMsg, setErrorMsg] = useState("");
  const [tagsList, setTagsList] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    setDataLoading(true);
    // getSolutionTagsByOfferingId();
    UserActivityAxios.get(
      `Solution/getsolutionsforconclave/${loggedInUser.offeringUserId}`
    )
      .then((res) => {
        //dispatch(SolutionSlice.actions.setSolutionSlice([...res.data]));
        setSolutionList([]);
        setSolutionList(res.data);
        setDataLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });

    ProgramSetupAxios.get(
      `OfferingRatings/offeringratings/${loggedInUser.offeringId}`
    )
      .then((res) => {
        //dispatch(SolutionSlice.actions.setSolutionSlice([...res.data]))
        setOfferingRatingTypes([]);
        setOfferingRatingTypes(res.data.ratingTypes);
        setOfferingRatings(
          res.data.ratings.filter((x) => x.isOverallRating !== true) || []
        );
        var temp = res.data.ratings.filter(
          (x) => x.isOverallRating === true
        )[0];
        setOverallRating(temp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // useEffect(() => {
  //   if (offeringRatings.length > 0) {
  //     let tags = [];

  //     offeringRatings.map((x) => {
  //       let tag = { id: x.tagId };
  //       let name = tagsList.find((y) => y.value === x.tagId).label;
  //       tag.name = name;
  //       // push unique tags to array
  //       if (!tags.find((y) => y.id === tag.id)) {
  //         tags.push(tag);
  //       }
  //     });

  //     console.log(tags);
  //     setTags(tags);
  //     console.log("tags", tags);
  //   }
  //   console.log("offeringRatings", offeringRatings);
  // }, [tagsList, offeringRatings]);

  // const getSolutionTagsByOfferingId = () => {
  //   ProgramSetupAxios.get(
  //     "/SolutionTag/getsolutiontags/" + loggedInUser.offeringId
  //   )
  //     .then(function (response) {
  //       let tagsList = response.data.map((item) => {
  //         return {
  //           label: item.tagName,
  //           value: item.id,
  //         };
  //       });
  //       tagsList = tagsList.sort((a, b) => (a.id > b.id ? 1 : -1));
  //       setTagsList(tagsList);
  //       console.log("tagsList", tagsList);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };

  const handleOpenNominationModal = (solutionId) => {

    //to do return on isRated True 


    UserActivityAxios.get(
      `Solution/getsolutionbyid/${solutionId}/${loggedInUser.offeringUserId}`
    )
      .then((res) => {
        setErrorMsg("");
        setSelectedSolution(res.data);
        setShowNominationModal(true);
        setFeedbackText(res.data.ratingFeedback);


        let localTags = res.data.solutionTags.map(item => { return { id: item.id, name: item.tagName }; });

        setTags(localTags);


        // if (res.data.solutionRatings.length > 0)
        //     setButton("View Rating")
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleCloseNominationModal = () => {
    setSelectedSolution(null);
    setFeedbackText("");
    setShowNominationModal(false);
    setUpdatedRatings([]);
  };

  const handleTextAreaChange = (e) => {
    setFeedbackText(e.target.value);
  };

  const handleRating = (item, rate) => {
    var temp = [...updatedRatings];

    var index = temp.findIndex((x) => x.ratingId === item.id);

    if (index > -1) temp.splice(index, 1);

    temp.push({
      solutionId: selectedSolution.id,
      ratingId: item.id,
      maxRating: item.maxRating,
      ratingValue: (rate * item.maxRating) / 100,
    });
    setUpdatedRatings(temp);
  };


  const getRating = (item) => {
    if (selectedSolution && selectedSolution.solutionRatings.length > 0) {
      var temp = selectedSolution.solutionRatings.filter(
        (x) => x.ratingId === item.id
      );
      if (temp && temp.length > 0)
        return temp[0].value;
      else return 0;
    } else {
      return 0;
    }
  };

  const getRatingType = (item) => {
    if (selectedSolution && selectedSolution.solutionRatings.length > 0) {
      var temp = selectedSolution.solutionRatings.filter(
        (x) => x.ratingId === item.id
      );
      if (temp && temp.length > 0) return temp[0].valueText;
      else return "";
    } else {
      return "";
    }
  };

  const submitRating = () => {
    if (selectedSolution.solutionRatings.length > 0) {
      selectedSolution.solutionRatings.forEach((item) => {
        var temp = updatedRatings.find((x) => x.ratingId == item.ratingId);
        if (!temp) {
          updatedRatings.push({
            solutionId: selectedSolution.id,
            ratingId: item.ratingId,
            maxRating: item.maxRating,
            ratingValue: item.value,
          });
        }
      });
    }
    let tempList = offeringRatings.filter(x => tags.some(k => k.id == x.tagId));
    if (tempList.length > updatedRatings.length) {
      setErrorMsg("Please provide your rating for all parameters.");
      return;
    }

    updatedRatings.forEach(element => {
      if (element.ratingValue < 1) {
        element.ratingValue = element.ratingValue * 20;
      }
    });

    var data = {
      ratings: updatedRatings,
      feedback: feedbackText,
      solutionId: selectedSolution.id,
      ratedBy: loggedInUser.firstName + " " + loggedInUser.lastName,
      offeringUserId: loggedInUser.offeringUserId
    };
    var requestObject = {
      requestModel: data,
      message: messagePoint,
      isBackgroundJob: false,
    };
    UserActivityAxios.put(`Solution/ratesolution`, requestObject)
      .then((res) => {
        handleCloseNominationModal();
        setErrorMsg("");
        let temp = [...solutionList];

        if (temp.findIndex((x) => x.id == selectedSolution.id) >= 0) {
          temp[temp.findIndex((x) => x.id == selectedSolution.id)][
            "isRated"
          ] = true;
          setSolutionList(temp);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const getOverallRating = (sol) => {
    if (sol.solutionRatings && sol.solutionRatings.length > 0) {
      let avg = sol.solutionRatings.reduce((a, b) => a + b.value, 0) / sol.solutionRatings.length;
      return Math.round(avg * 100) / 100;
    }
    else return 0;
  };


  return (
    <>
      <div className="px-3 py-4 scroll-content">
        <ContentHeading title={"Nominate Solutions"} />
        <div className="content-padding nominate-solutions">
          <div className="nominate-title">
            <div>Nominate and rate solutions below for different award categories.</div>
          </div>
          <div className="row solution-flex-wrapper">
            {solutionList &&
              solutionList.map((item, index) => {
                return (
                  <SolutionItem
                    className="col solution-item"
                    {...item}
                    key={"solution" + index}
                    openRatingModal={handleOpenNominationModal}
                    button={"Rate"}  // is Rate = true disable
                  />

                );
              })}

            {
              dataLoading && <div className="loading-container" ><span className="me-2">Loading </span><Spinner className="m-0" animation="border" variant="primary" size="sm" /></div>
            }

            {
              !dataLoading && solutionList.length == 0 && <div className="nominate-title"><span><i>Solution not submitted by any team yet!</i></span></div>
            }
          </div>
        </div>
        <ContentHeading title={"Discuss with your Conclave"} />
        <div className="content-padding pt-4">
          <PostComment
            showAssignment={false}
            forumId={selectedForumId}
            reloadComments={reloadData}
          ></PostComment>
          {selectedForum &&
            selectedForum.comments &&
            selectedForum.comments
              .sort((a, b) => (a.commentedOn < b.commentedOn ? 1 : -1))
              .map((item, index) => {
                return (
                  <Comment
                    thread={selectedForum && selectedForum.forumTitle}
                    key={`comment${index}-${item.id}`}
                    forumId={selectedForumId}
                    setLikeItem={setLikeItem}
                    reloadComments={reloadData}
                    comment={item}
                  />
                );
              })}
          {selectedForum?.comments?.length >= pageSize && activeShowMore && (
            <ShowMore onClick={() => setOnClickShowMore(true)} />
          )}
        </div>

      </div>

      <CdxModal
        show={showNominationModal}
        onHide={handleCloseNominationModal}
        animation={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="nominate-solution-modal"
      >
        <CdxModal.Header
          onClose={handleCloseNominationModal}
          style={{ paddingTop: "10px" }}
          noBorder={true}
          className="rating-modal-header"
        >
          {selectedSolution && (
            <div className="rating-header-wrapper w-100">
              {
                <div className="rating-header title">
                  {selectedSolution.solutionName}, <a className="team-name">{selectedSolution.teamName}</a>
                </div>
              }
            </div>
          )}
        </CdxModal.Header>
        <CdxModal.Body className="rating-body ">
          {overallRating && selectedSolution && (
            <>
              <div className="overall-rating-div mb-3">
                {overallRating && (
                  <div className="ratings-info">
                    <div className="d-flex">
                      {overallRating.name} Rating:
                      <div className="type">
                        {selectedSolution.overallRating}
                      </div>
                    </div>
                    <div className="ratings">
                      <Rating
                        initialValue={
                          getOverallRating(selectedSolution)
                        }
                        iconsCount={selectedSolution.maxRating}
                        fillColor="#00FFCA"
                        size={20}
                        allowFraction={true}
                        readonly
                      />
                      <div className="d-flex">
                        <span className="value">
                          {getOverallRating(selectedSolution)}
                        </span>
                        {"/" + selectedSolution.maxRating}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="rating-section">
                {tags && tags.map((item, index) => {
                  return (<>
                    <div className="tag-item" key={"tag-" + index}>
                      <div className="tag-name">{item.name}</div>
                      <Row className="star-rows">
                        {offeringRatings &&
                          offeringRatings.filter(x => x.tagId === item.id).map((item, index) => {
                            let newRate = updatedRatings.find(x => x.ratingId == item.id);
                            let newType = newRate && offeringRatingTypes.find(x => x.sortOrder == newRate.ratingValue);
                            let newLabel = newType && newType.name;

                            return (
                              <Col key={index} sm={6} className="mb-2">
                                <div className="ps-2 mb-1">{item.name}*</div>
                                <div className="start-background">
                                  <div className="">
                                    <Rating
                                      onClick={(value) => {
                                        handleRating(item, value);
                                      }}
                                      initialValue={getRating(item)}
                                      iconsCount={item.maxRating}
                                      fillColor="#00FFCA"
                                      size={18}
                                    />
                                  </div>

                                  <span className="rateTextValue">
                                    <nobr>{newLabel && newLabel || getRatingType(item)}</nobr>
                                  </span>
                                </div>
                              </Col>
                            );
                          })}
                      </Row>
                    </div>
                  </>
                  );
                })}
              </div>

              <TextAreaInput
                label="Feedback"
                id="feedback"
                name="feedback"
                rows="3"
                value={feedbackText}
                maxLength="200"
                placeholder="Write your text here..."
                className="rating-feedback"
                onChange={handleTextAreaChange}
              />
            </>
          )}
        </CdxModal.Body>
        <CdxModal.Footer className="rating-footer">
          {errorMsg && (
            <span style={{ color: "red", textAlign: "right" }}>{errorMsg}</span>
          )}
          <button className="cdx-btn" onClick={submitRating}>
            {selectedSolution && selectedSolution.solutionRatings.some(x => x.offeringUserId == loggedInUser.offeringUserId)
              ? "Update"
              : "Submit"}
          </button>
        </CdxModal.Footer>
      </CdxModal>
    </>
  );
};

export default NominateTab;
